import {DialogTitle} from '@apps-common/ui-components';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import {bool, func} from 'prop-types';
import React from 'react';

const ReleaseConfirmationModal = ({
  onClose,
  isReleasing,
  onReleaseClick,
  open,
}) => {
  return (
    <Dialog open={open} fullWidth maxWidth="sm" onClose={onClose}>
      <DialogTitle
        onClose={onClose}
        title="Are you sure you want to release quota?"
      />
      <DialogContent>
        <Typography>
          Releasing quota refunds quota back to an organization&apos;s available
          quota. Once quota is released, users in the organization will no
          longer be able to create new requests for data in the released AOIs.{' '}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          disabled={isReleasing}
          onClick={onReleaseClick}
        >
          {isReleasing ? 'Releasing...' : 'Release quota'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ReleaseConfirmationModal.propTypes = {
  onClose: func,
  open: bool,
  onReleaseClick: func,
  isReleasing: bool,
};

export default ReleaseConfirmationModal;
